export function nullify<K extends string>(...properties: readonly K[]) {
  return <T extends Readonly<{ [k in K]: any }>>(obj: T): T =>
    properties.reduce((handle, property) => {
      (handle as any)[property] = null;
      return handle;
    }, Object.assign({}, obj));
}
